import './FormAction.css';
import ActionType from '../../../data/constant/types/ActionType';
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import TitleBlock from '../TitleBlock/TitleBlock';
import BlockList from '../../../data/constant/BlocksList';
import NiceModal from '@ebay/nice-modal-react';
import FormList from '../FormList';
import useBlock from '../../../hook/block/useBlock';


// This form allow user to change the type of block action, thath action cannot be reverted
function FormAction( { name, id }) {

    // Just a map to get all action type / text
    const actions = Object.entries(ActionType).map(([key, value]) => { return { text : value, value : key } });

    const { updateBlockAction } = useBlock()

    const defaultAction = actions.pop();

    const setValueDropdown = (name, value) => {
        // Change block type 
        const block = BlockList[value];
        const Component = FormList[value];
        const res = updateBlockAction(id, block);
        NiceModal.show('editor-window', { Component,  componentProps : {name : res.name, id} });
    }
    
    return (
        <>
            <TitleBlock title="Action" titleInput="Action name" name={name} id={id}/>
            <div className='area-edit'>
                <label className="input_title">Action type</label>
                <Dropdown choices={actions} placeholder={defaultAction.text} width="calc(100%)" name="action_type" setValue={setValueDropdown}/>
            </div>
        </>
    )
}

export default FormAction;